import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { EmptyContainerPageRoutingModule } from './empty-container-routing.module';

import { EmptyContainerPage } from './empty-container.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    EmptyContainerPageRoutingModule
  ],
  exports: [EmptyContainerPage],
  declarations: [EmptyContainerPage]
})
export class EmptyContainerPageModule {}
